import { render, staticRenderFns } from "./file_content_linked_wysiwyg.vue?vue&type=template&id=b1137dce&scoped=true&lang=pug"
import script from "./file_content_linked_wysiwyg.vue?vue&type=script&lang=js"
export * from "./file_content_linked_wysiwyg.vue?vue&type=script&lang=js"
import style0 from "./file_content_linked_wysiwyg.vue?vue&type=style&index=0&id=b1137dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1137dce",
  null
  
)

export default component.exports